import useSite from "src/core/sites/hooks/useSite";

export default function useTitle() {
  const site = useSite();
  return {site};
}
